import Children from '../../../layouts/Children';

const routes = [
  {
    path: 'users',
    component: Children,

    children: [
      {
        path: '',
        name: 'users',
        component: () => import('../pages/Users.vue')
      }
    ]
  }
];

export default routes;
